/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

const Colors = {
  white: '#FFFFFF',
  lightBlack: '#0E0E0E',
  opacityWhite: '#FFFFFFDD',
  black: '#000000',
  opacityBlack: '#00000022',
  light: '#F2F2F20F',
  brand: '#E60000',
  transparent: 'transparent',
  lightGrey: '#D4DbE5',
  darkGrey: '#91949D',
  darker: '#151515',
  transparentDark: 'rgba(45, 32, 230, 0.2)',
  shimmer: '#4A4D4E66',
};

export default Colors;
